// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"253":"9cc574af","490":"febc8fe9","513":"454731dd","676":"4ccc50d4","852":"060904dc","939":"3618df86"}[chunkId] + ".js";
};